export default [{
  title: '政策指引篇',
  list: [{
    title: '全国扫黑除恶专项斗争什么时候开始？'
  },
  {
    title: '扫黑除恶专项斗争的“总蓝图”是什么？'
  },
  {
    title: '扫黑除恶专项斗争的重大意义是什么？'
  },
  {
    title: '扫黑除恶的主要特点是什么？'
  },
  {
    title: ' 扫黑除恶专项斗争的基本原则是什么？'
  },
  {
    title: ' “扫黑除恶”中的“黑”与“恶”指的是什么？'
  },
  {
    title: ' “黑社会性质的组织”应当同时具备哪“四个特征”？'
  },
  {
    title: ' “恶势力犯罪集团”的特征及具体表现是什么？·'
  },
  {
    title: '  什么是黑恶势力“保护伞”？'
  },
  {
    title: '  “软暴力”具体表现是什么？'
  },
  {
    title: '  “扫黑”与“打黑”有什么区别？'
  },
  {
    title: '  扫黑除恶专项斗争打击的重点是什么？'
  },
  {
    title: '  涉黑涉恶线索举报受理的范围有哪些？'
  },
  {
    title: '  扫黑除恶专项斗争应做到哪“两个结合”？'
  },
  {
    title: '  扫黑除恶专项斗争“两个一律”指什么？'
  },
  {
    title: '  扫黑除恶专项斗争“一案三查”指什么？'
  },
  {
    title: '  扫黑除恶专项斗争有哪些工作措施？'
  },
  {
    title: '   扫黑除恶的十项重点工作是什么？'
  },
  {
    title: '   铲除黑恶势力滋生土壤的治本之策、关键之举是什么？'
  },
  {
    title: '   扫黑除恶的第一责任、直接责任、行业监管责任是什么？'
  },
  {
    title: '   扫黑除恶对涉黑涉恶问题突出地区、行业、领域追责方式是什么？'
  },
  {
    title: ' 纪检监察机关在扫黑除恶专项斗争中重点查处的3类问题指的是什么？'
  },
  {
    title: ' 组织部门在扫黑除恶专项斗争中的工作重点是什么？'
  },
  {
    title: ' “村霸”问题的主要表现形式是哪5种？'
  },
  {
    title: ' 扫黑除恶如何形成长效工作机制？'
  },
  {
    title: '全国扫黑除恶专项斗争中督导工作的“六个围绕、六个重点”指什么？'
  },
  {
    title: ' 对不属于涉黑涉恶案件的违法犯罪行为，应如何报案？'
  },
  {
    title: ' 昆明市扫黑除恶举报电话有哪些？'
  },
  {
    title: ' 昆明市群众举报暴力恐怖犯罪线索有哪些奖励？'
  }
  ]
},
{
  title: '法律指导篇',
  list: [{
    title: ' 什么是黑社会性质组织？'
  },
  {
    title: ' 什么是恶势力？'
  },
  {
    title: ' 黑恶势力为谋取不法利益煽动闹事等行为的法律后果是什么？'
  },
  {
    title: ' 什么是入境发展黑社会组织罪？·'
  },
  {
    title: ' 什么是故意伤害罪？'
  },
  {
    title: ' 什么是聚众扰乱社会秩序罪？'
  },
  {
    title: ' 什么是强迫交易罪？'
  },
  {
    title: ' 什么是敲诈勒索罪？'
  },
  {
    title: ' 什么是寻衅滋事罪？'
  },
  {
    title: ' 什么是聚众斗殴罪？'
  },
  {
    title: ' 什么是非法拘禁罪？'
  },
  {
    title: ' 什么是故意毁坏财物罪？'
  },
  {
    title: ' 什么是组织卖淫罪？'
  },
  {
    title: ' 什么是强迫卖淫罪？·'
  },
  {
    title: ' 什么是开设赌场罪？'
  },
  {
    title: ' 什么是非法经营罪？'
  },
  {
    title: ' 什么是套路贷？'
  },
  {
    title: ' 什么是校园贷？有哪些特征？'
  }
  ]
},
{
  title: '举案指路篇',
  list: [{
    title: ' 你的行为可能涉嫌开设赌场罪或赌博罪吗？'
  },
  {
    title: ' 你的行为可能构成非法经营罪吗？'
  },
  {
    title: ' 你的行为可能构成传授犯罪方法罪吗？'
  },
  {
    title: ' 你的行为可能构成编造、故意传播虚假信息罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌容留卖淫罪、介绍卖淫罪、容留他人吸毒罪吗？'
  },
  {
    title: ' 你的行为可能构成故意伤害罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌玩忽职守罪或滥用职权罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌非法狩猎野生动物罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌非法釆矿罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌运输毒品罪吗？'
  },
  {
    title: ' 你的行为可能涉嫌非法讨债吗?'
  },
  {
    title: ' 你的行为可能成为“扫黑除恶”的打击对象吗？'
  },
  {
    title: ' 你的行为可能成为犯罪帮凶吗？'
  },
  {
    title: ' 你的行为与黑恶势力沾边吗？'
  },
  {
    title: ' 你有可能被黑恶势力团伙利用吗？'
  },
  {
    title: ' 你的行为可能涉嫌“市霸”吗？'
  },
  {
    title: ' 你的行为涉嫌黑恶势力的“保护伞”吗？'
  }
  ]
}
]
